import dayjs from 'dayjs';
import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';
import { OpenAccessProtocol, OpenAccessProtocolType } from './open-access-protocol.js';
import { TimeZone } from '../../../time/timezone.js';

/**
 * @deprecated Use EventOpenAccessProtocol instead
 */
export class LimitedTimeAccessProtocol extends OpenAccessProtocol {
  static readonly TYPE_ID: string = 'f508ec32762e4bca95322c09f838c8c3';

  public readonly type: OpenAccessProtocolType = OpenAccessProtocolType.LimitedTime;

  constructor(
    public readonly expirationDate: dayjs.Dayjs,
  ) {
    super();
  }

  get $typeId(): string {
    return LimitedTimeAccessProtocol.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): LimitedTimeAccessProtocol {
    return new LimitedTimeAccessProtocol(
        TimeZone.decodeDate(MapUtils.get<number>(map, 'expirationDate')),
    );
  }

  toMap(context: SerializationContext):SerializedData {
    return {
      'type': fromEnumAsString(this.type),
      'expirationDate': TimeZone.encodeDate(this.expirationDate),
    };
  }

  clone(): this {
    return new LimitedTimeAccessProtocol(
        TimeZone.cloneDate(this.expirationDate)
    ) as this;
  }

  isSame(other: LimitedTimeAccessProtocol): boolean {
    if(other === this) {
      return true;
    }

    return other.expirationDate == this.expirationDate;
  }

  applyTemplateChanges(other: this): this {
    return new LimitedTimeAccessProtocol(
        TimeZone.cloneDate(other.expirationDate)
    ) as this;
  }

  static verifyType(dm: DataModel): boolean {
    return dm instanceof LimitedTimeAccessProtocol;
  }

  static assertType(dm: DataModel): dm is LimitedTimeAccessProtocol {
    return dm instanceof LimitedTimeAccessProtocol;
  }
}

export class LimitedTimeAccessProtocolBuilder extends DataModelBuilder<LimitedTimeAccessProtocol> {
  build(context: SerializationContext, map: SerializedData): LimitedTimeAccessProtocol {
    return LimitedTimeAccessProtocol.fromMap(context, map);
  }
}
